// extracted by mini-css-extract-plugin
export default {"titlePage":"SetUpMethod_titlePage__jYsHN","subtitlePage":"SetUpMethod_subtitlePage__7finl","customLink":"SetUpMethod_customLink__o5A82"};